/**
 * This wizard was created with the intention
 * of mounting one step at a time,
 * instead of mounting all steps on initial load,
 * which is the case with the original 'Wizard' component.
 */

import React, { FC } from "react";
import WizardSideBarStep from "../../models/WizardSideBarStep";
import Card from "../card/card";
import CardBody from "../card/card-body";
import CardHeader from "../card/card-header";
import WizardSideBar from "../wizard-sidebar/wizard-sidebar";
import closeIcon from '../../images/close.svg';
import { useFormikContext } from "formik";

interface WizardTwoProps {
    onClose: () => void;
    step: number;
    name: string;
    sidebarSteps: WizardSideBarStep[];
    stepContent: JSX.Element[];
}

const WizardTwo: FC<WizardTwoProps> = ({ name, onClose, step, sidebarSteps, stepContent }) => {
    const { resetForm } = useFormikContext<any>();

    return <div className='wizard relative' id='wizard-two'>
        <Card style={{ maxHeight: 560 }} className="h-full flex flex-col">
            <CardHeader className={`flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                <div className="flex flex-row">
                    <p className="pl-3 font-bold font text-white">{name}</p>
                </div>
                <img src={closeIcon} onClick={() => { resetForm(); onClose() }} className="cursor-pointer mr-2" id='closeWizardTwoIcon' />
            </CardHeader>
            <div className={`flex flex-row h-full`}>
                <WizardSideBar isExpanded={true} step={step} steps={sidebarSteps}></WizardSideBar>
                <CardBody className={`px-2 h-full ${sidebarSteps && sidebarSteps.length > 0 ? '' : 'w-full'}`} style={sidebarSteps && sidebarSteps.length > 0 ? { minWidth: 560, maxHeight: 510 } : {}}>
                    {stepContent[step]}
                </CardBody>
            </div>
        </Card>
    </div>
}

export default WizardTwo;